<template>
  <div>
    <div ref="comp" v-touch:swipe="swipeHandler" class="mobile-target">
      <div id="personaldetails" class="application-section personal-details">
        <section id="nameSection">
          <div class="container is-fluid">
            <ChooseQuestion :existingValue="this.personalDetails.title"
                            question="Title" :options="titles"
                            @question-answered="titleSelected" :class="{error: $v.personalDetails.title.$error }"
                            :isMandatory="true" :isDisplayedBlock="true" :isDropdownControlled="true" :tab="sections.nameSection.tab" />
            <div>
              <span class="displayblock form-label">First name</span>
              <b-input v-model.trim="$v.personalDetails.firstname.$model" placeholder="First name"
                       :class="[{mandatory : true}, {error: $v.personalDetails.firstname.$error}]" :tabindex="sections.nameSection.tab">
              </b-input>
            </div>
            <div>
              <span class="displayblock form-label">Last name</span>
              <b-input v-model.trim="$v.personalDetails.lastname.$model" placeholder="Last name"
                       :class="[{mandatory : true}, {error: $v.personalDetails.lastname.$error}]" :tabindex="sections.nameSection.tab">
              </b-input>
            </div>
          </div>
        </section>
        <section id="emailSection">
          <div class="container is-fluid">
            <div>
              <span class="displayblock form-label">Email</span>
              <b-field :message="{'Email is not valid': !$v.personalDetails.email.email}">
                <b-input type="email" v-model.trim="$v.personalDetails.email.$model" placeholder="Email"
                         :class="[{mandatory: true}, {error: $v.personalDetails.email.$error }]" size="is-large"
                         icon="email" autocomplete="new-email" :tabindex="sections.emailSection.tab"></b-input>
              </b-field>
            </div>
            <div v-if="!isLoggedIn">
              <span class="displayblock form-label">Confirm email</span>
              <b-field :message="{ 'The emails do not match': !$v.personalDetails.confirmEmail.sameAs }">
                <b-input type="email" v-model.trim="$v.personalDetails.confirmEmail.$model" placeholder="Confirm email"
                         :class="[{mandatory: true}, {error: $v.personalDetails.confirmEmail.$error }, 'common-input']" icon="email"
                         size="is-large" autocomplete="new-email" :tabindex="sections.emailSection.tab">

                </b-input>
              </b-field>
            </div>
          </div>
        </section>
        <section v-if="!isLoggedIn" id="passwordSection">
          <div class="container is-fluid">
            <div>
              <span class="displayblock form-label">Password</span>
              <b-field :message="[{ 'Password must have at least 8 non-unicode characters': !$v.personalDetails.password.passwordRegex},
                          { 'It needs to contain at least 3 out of 4 of the following': !$v.personalDetails.password.passwordRegex},
                       { 'Uppercase characters, lowercase characters, specific symbols and numbers': !$v.personalDetails.password.passwordRegex}]">
                <b-input type="password" password-reveal v-model.trim="$v.personalDetails.password.$model" placeholder="Password"
                         :class="[{mandatory:true}, { error: $v.personalDetails.password.$error}]" autocomplete="new-password"
                         :tabindex="sections.passwordSection.tab"></b-input>
              </b-field>
            </div>
            <div>
              <span class="displayblock form-label">Confirm password</span>
              <b-field :message="{ 'The passwords do not match': !$v.personalDetails.confirmPassword.sameAsPassword}">
                <b-input type="password" password-reveal v-model.trim="$v.personalDetails.confirmPassword.$model" placeholder="Confirm password"
                         :class="[{mandatory:true}, { error: $v.personalDetails.confirmPassword.$error}]" autocomplete="new-password"
                         :tabindex="sections.passwordSection.tab"></b-input>
              </b-field>
            </div>
          </div>
        </section>
        <section id="tncsSection">
          <div class="container is-fluid">
            <DateQuestion :existingValue="personalDetails.dob" question="Date of birth"
                          @question-answered="dateOfBirthEntered" :class="{error: $v.personalDetails.dob.$error }"
                          :isMandatory="true" :isDisplayedBlock="true" :isDropdownControlled="false"
                          :dateMask="birthdateMask" :tab="sections.tncsSection.tab" />
            <p v-if="$v.personalDetails.dob.$error" class="help is-danger">Please enter your date of birth as DD/MM/YYYY</p>
            <b-field :message="{'Email is not valid': !$v.personalDetails.email.email}">
            </b-field>
            <div class="form-border">
              <b-checkbox type="checkbox" v-model.trim="$v.personalDetails.tncs.$model"
                          :class="[{mandatory:true}, { error: $v.personalDetails.tncs.$error}]" :disabled="sections.tncsSection.tab == -1">
                <span class="displayblock form-label confirm-size"> I confirm that I agree to abide by the Royal College of Pharmacy's </span>
                <span class="form-label tncs-size">
                  <a href="https://www.rcpharm.org/membership-terms-and-conditions" target="_blank">
                    Membership Terms and Conditions
                  </a>
                </span>
              </b-checkbox>
            </div>
            <div v-if="$v.personalDetails.tncs.$error">
              <p class="help">Please accept Terms and Conditions before continue.</p>
            </div>
            <div v-if="!this.isMobile" id="confirm-wrap">
              <div><button @click.stop.prevent="confirm" class="form-button" type="button">Next</button></div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <NextButton @clicked="navigateNext" />
  </div>
</template>
<script>
/* eslint  no-useless-escape: "warn" */

import ChooseQuestion from '@/components/ChooseQuestion.vue';
import api from '@/api';
import DateQuestion from '@/components/DateQuestion.vue';
import '@/styles/inputform.scss';
import {
  requiredIf, minLength, sameAs, email, helpers, required,
} from 'vuelidate/lib/validators';
import {
  mapGetters, mapState, mapMutations,
} from 'vuex';
import NextButton from '@/components/NextButton.vue';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayJs from 'dayjs';
import Mobile from '../mobile/mobile';
import Manager from '../applicationManager';
import Ga from '../ga';

dayJs.extend(customParseFormat);
const dobMinValue = function (val) {
  const minDate = dayJs('01/01/1900', 'DD/MM/YYYY');
  const dob = dayJs(val, 'DD/MM/YYYY');
  if (!dob.isValid()) return false;
  if ((val.substr(val.length - 4)) === '0000') return false;

  return dob.isAfter(minDate);
};

export default {
  name: 'PersonalDetails',
  components: {
    DateQuestion,
    ChooseQuestion,
    NextButton,
  },
  data() {
    return {
      passwordRegexPattern: null,
      personalDetails: null,
      birthdateMask: {
        date: true,
        dateMax: `${new Date().getFullYear() - 16}-01-01`,
        dateMin: '1900-01-01',
        datePattern: ['d', 'm', 'Y'],
      },
      sections: {
        nameSection: { tab: 0 },
        emailSection: { tab: this.isMobile ? -1 : 0 },
        passwordSection: { tab: this.isMobile ? -1 : 0 },
        tncsSection: { tab: this.isMobile ? -1 : 0 },
      },
    };
  },
  created() {
    if (this.getPersonalDetail.title === 'Other') {
      this.getPersonalDetail.title = null;
    }
    this.personalDetails = this.getPersonalDetail;
  },
  mounted() {
    Ga.sendUserRegistered(this.application.Type);
    this.fetchPasswordRegex();
    if (this.application.Type !== 'Student') { Ga.sendEmploymentDetails(this.application.Type); }
    if (this.isMobile) {
      this.initSections();
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'titles', 'getPersonalDetail', 'isFinalSection']),
    ...mapState(['isMobile', 'application']),
  },
  validations() {
    return {
      personalDetails: {
        title: {
          required,
        },
        firstname: {
          required,
        },
        lastname: {
          required,
        },
        email: {
          required,
          email,
        },
        confirmEmail: {
          required: requiredIf(() => !this.isLoggedIn),
          email,
          sameAs: sameAs('email'),
        },
        password: {
          required: requiredIf(() => !this.isLoggedIn),
          minLength: minLength(8),
          passwordRegex: this.passwordRegexPattern
            ? helpers.regex('password', this.passwordRegexPattern)
            : () => true,
        },
        confirmPassword: {
          required: requiredIf(() => !this.isLoggedIn),
          sameAsPassword: sameAs('password'),
        },
        dob: {
          required: requiredIf(() => true),
          minLength: minLength(10),
          dobMinValue,
        },
        tncs: {
          sameAs: sameAs(() => true),
        },
      },
    };
  },
  methods: {
    ...mapMutations(['completePersonalDetails']),
    navigateNext() {
      if (this.isFinalSection) {
        this.confirm();
      } else this.swipeHandler('left');
    },
    fetchPasswordRegex() {
      api.getPasswordRegex()
        .then((response) => {
          this.passwordRegexPattern = new RegExp(response.data.regex);
          console.log(this.passwordRegexPattern);
        })
        .catch((error) => {
          console.error('Error fetching password regex:', error);
        });
    },
    async confirm() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        this.$nextTick(() => {
          // - 100 is offset because of Sticky positional DNN header.
          window.scrollTo(0, (document.querySelector('.error').getBoundingClientRect().top - 100) + window.pageYOffset);
        });
        return;
      }
      // Only save if they are a new user
      if (!this.isLoggedIn) {
        this.completePersonalDetails({ personalDetails: this.personalDetails });

        this.$emit('saveInProgress', true);
        // Send to api
        const result = await Manager.savePersonalDetails();

        this.$emit('completed', { message: result.message, successful: result.successful, title: result.title });
      } else {
        this.$emit('saveInProgress', true);
        const details = { ...this.personalDetails, userId: this.application.UserInfo.userId };
        const result = await Manager.updatePersonDetails(details);

        this.$emit('completed', { message: result.message, successful: result.successful, title: result.title });
      }

      window.scroll(0, 20);
    },
    initSections() {
      Mobile.initSections(this.$el.querySelector('.application-section'));
    },
    swipeHandler(direction) {
      Mobile.swipeHandler(direction, this);
    },
    HasErrorInSection(currentSection) {
      if (this.isLoggedIn) {
        return this.$v.personalDetails.tncs.$touch();
      }

      if (currentSection === 'nameSection') {
        this.$v.personalDetails.title.$touch();
        this.$v.personalDetails.firstname.$touch();
        this.$v.personalDetails.lastname.$touch();
        return this.$v.personalDetails.title.$error || this.$v.personalDetails.firstname.$error || this.$v.personalDetails.lastname.$error;
      }
      if (currentSection === 'emailSection') {
        this.$v.personalDetails.email.$touch();
        this.$v.personalDetails.confirmEmail.$touch();
        return this.$v.personalDetails.email.$error || this.$v.personalDetails.confirmEmail.$error;
      }
      if (currentSection === 'passwordSection') {
        this.$v.personalDetails.password.$touch();
        this.$v.personalDetails.confirmPassword.$touch();
        return this.$v.personalDetails.password.$error
            || this.$v.personalDetails.confirmPassword.$error;
      }
      if (currentSection === 'tncsSection') {
        this.$v.personalDetails.tncs.$touch();
        this.$v.personalDetails.dob.$touch();
        return this.$v.personalDetails.dob.$error
            || this.$v.personalDetails.tncs.$error;
      }
      return false;
    },
    titleSelected(t) {
      this.$v.personalDetails.title.$touch();
      this.personalDetails.title = t.text;
    },
    dateOfBirthEntered(d) {
      this.$v.personalDetails.dob.$touch();
      this.personalDetails.dob = d;
    },
    SetIndexes(current, next) {
      this.sections[current].tab = -1;
      this.sections[next].tab = 0;
    },
  },
};
</script>
